<script setup>
/* eslint-disable */
import { onMounted, watch, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import CompetitionFixtures from './CompetitionFixtures.vue';
import { useTimedSportStore } from '@/stores/timed_sport';
import _ from 'lodash';

const router = useRouter();
const timedSportStore = useTimedSportStore();

const props = defineProps({
	primary_overview_market: {
		type: Object,
		required: true,
	},
	secondary_overview_market: {
		type: Object,
		required: true,
	},
	time: {
		type: String,
		default: 'today',
	},
	sport_id: {
		type: Number,
		default: 1,
	},
	competition_ids: {
		type: String,
		default: '',
	},
	pre_only: {
		type: Boolean,
		default: false,
	},
});

const loading = ref(false);

const competitions = computed(() => {
	if (!props.competition_ids && !props.pre_only) {
		return timedSportStore.competitions_by_time;
	}

	let competition_ids_array = props.competition_ids
		? (Array.isArray(props.competition_ids) ? props.competition_ids.map(String) : props.competition_ids.split(','))
		: null;

	return _.filter(timedSportStore.competitions_by_time, (competition) => {
		const matchesCompetition = !competition_ids_array || competition_ids_array.includes(competition.id.toString());
		const matchesPreOnly = !props.pre_only || competition.pre_fixtures_count > 0;

		return matchesCompetition && matchesPreOnly;
	});
});

const fetchCompetitions = () => {
	loading.value = true;
	timedSportStore.fetchRegionsByTime(props.sport_id, props.time).then(() => {
		loading.value = false;
	}).catch(() => {
		loading.value = false;
	});
};

watch([() => props.sport_id, () => props.time], () => {
	timedSportStore.clearCompetitionsByTime();
	fetchCompetitions();

});

onMounted(() => {
	timedSportStore.clearCompetitionsByTime();
	fetchCompetitions();
});
</script>

<template>
	<div id="popular" class="tab-content">

		<template v-if="!loading && competitions.length > 0">
			<div class="live-info-outer" v-for="(competition, index) in competitions" :key="index">
				<CompetitionFixtures
					:index="index"
					:competition="competition"
					:primary_overview_market="primary_overview_market"
					:secondary_overview_market="secondary_overview_market"
					:time="time"
					:sport_id="sport_id"
					:pre_only="pre_only"
				/>
			</div>
		</template>

		<div v-else-if="!loading && competitions.length === 0" class="empty-state">
			<div class="empty-state-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
					<circle cx="12" cy="12" r="10"/>
					<line x1="12" y1="8" x2="12" y2="12"/>
					<line x1="12" y1="16" x2="12.01" y2="16"/>
				</svg>
			</div>
			<h3 class="empty-state-title">{{ $t('general.no_fixtures_available', 'No fixtures available') }}</h3>
			<p class="empty-state-subtitle">{{ $t('general.no_fixtures_message', 'There are no upcoming events for the selected time period. Try adjusting your filters or check back later.') }}</p>
		</div>
	</div>
</template>

<style scoped>
.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 24px;
	text-align: center;
	opacity: 0;
	animation: fadeIn 0.4s ease forwards;
}

@keyframes fadeIn {
	to { opacity: 1; }
}

.empty-state-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 80px;
	height: 80px;
	border-radius: 50%;
	background: rgba(var(--primary-rgb, 99, 162, 70), 0.08);
	color: var(--primary, #63A246);
	margin-bottom: 20px;
}

.empty-state-title {
	font-size: 1.15rem;
	font-weight: 600;
	color: var(--white, #fff);
	margin: 0 0 8px 0;
}

.empty-state-subtitle {
	font-size: 0.875rem;
	color: var(--light-gray, #8a8f98);
	margin: 0;
	max-width: 360px;
	line-height: 1.5;
}
</style>